function LoadCombination(name, combinationData) {
    this.name = name;
    this.prettyEquations = [];
    this.equations = [];
    this.prettyExclude = [];
    
    this.prettyEquations = combinationData["prettyEquations"];
    this.equations = combinationData["equations"];
    
    for( var i = 0; i < this.prettyEquations.length; i++ )
        this.prettyExclude.push(false);
    for( var i = 0; i < this.equations.length; i++ )
        this.equations[i]["exclude"] = false;
}

LoadCombination.prototype.togglePrettyExclude = function(index) {
    if( index >= this.prettyExclude.length || index < 0 ) return;
    let countTrue = this.prettyExclude.filter( x => { return x === true }).length
    if(countTrue === this.prettyExclude.length - 1) {
        alert("You must select at least one load case");
        return;
    }
    this.prettyExclude[index] = !this.prettyExclude[index];
    this.equations[index]["exclude"] = !this.equations[index]["exclude"];
}

const lrfdCombinations = new LoadCombination('LRFD', lrfdComboData);
const asdCombinations = new LoadCombination('ASD', asdComboData);
const noCombinations = new LoadCombination('No Combos', noComboData);
const serviceCases = new LoadCombination('Service Combos', serviceComboData);